import { render } from "./HelixBreadcrumbs.vue?vue&type=template&id=7dc398a6"
import script from "./HelixBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./HelixBreadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__